import { debug } from '../../utils/debug'
import { selectCanNavigateBack } from '../selectors/runtime'
import type { NavigateBackAction } from '../types/actions'

import { actionFactory } from './factory'

/**
 * Navigates to a previously visited Step, either automatically going to the
 * previous Step or a specific one.
 *
 * TODO: unit test
 */
export const navigateBack = actionFactory<NavigateBackAction>(
  (state, { intendedStepId } = {}) => {
    // if there is a previously visited step
    if (!selectCanNavigateBack(state)) {
      debug('Unable to navigate back')

      return
    }

    // if we're navigating to the previous Step without a reference
    if (typeof intendedStepId === 'undefined') {
      // removes the last item from the navigated path
      state.navigatedPath.pop()

      return
    }

    const currentIndex = state.navigatedPath.findIndex(
      (sid) => intendedStepId === sid
    )

    if (currentIndex === -1) {
      debug('Unable to navigate back. Intended step had not been visited')

      return
    }

    state.navigatedPath = state.navigatedPath.slice(0, currentIndex + 1)
  },
  'navigateBack'
)
